var exports = {
  "l": "x4ddf2309--7ce9e8--phone",
};

module.exports = exports;
